<template>
  <div>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">
        <!-- BEGIN: Bordered Table -->
        <div class="intro-y box mt-5">
          <div
            v-if="$h.isset(this.$store.state.auth.user)"
            class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
          >
            <div class="w-full sm:w-auto flex items-center justify-center">
              <select
                v-model="agencyId"
                type="text"
                class="input input--lg border w-full lg:w-auto mt-3 lg:mt-0 ml-auto"
                @change="updateTable()"
              >
                <option
                  v-for="(agency, index) in tmpAgencies"
                  :key="index"
                  :value="agency.id"
                >
                  <h2 class="font-medium text-base mr-auto">
                    {{ agency.name }}
                  </h2>
                </option>
              </select>
            </div>
            <div class="w-full flex items-center justify-between">
              <el-date-picker
                v-model="selectedDay"
                class="sm:ml-5 mt-3 sm:mt-0 w-24"
                type="date"
                placeholder="일별"
                value-format="yyyy-MM-dd"
                @change="updateTable()"
              >
              </el-date-picker>
              <div class="sm:w-auto flex items-center sm:ml-auto mt-3 sm:mt-0">
                <button
                  class="button px-2 mr-3 bg-theme-9 text-white"
                  @click="clickPlusBtn()"
                >
                  <span class="w-5 h-5 flex items-center justify-center">
                    <PlusIcon class="w-4 h-4" />
                  </span>
                </button>
                <button
                  class="button w-24 mr-1 bg-theme-12 text-white"
                  @click="exportExcel()"
                >
                  엑셀출력
                </button>
              </div>
            </div>
          </div>
          <div id="bordered-table" class="p-5">
            <div class="preview">
              <div class="overflow-x-auto">
                <div class="table">
                  <div class="grid grid-cols-12">
                    <div class="col-span-6">
                      <div
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                      >
                        입금
                      </div>
                      <div
                        v-for="(trans, index) in transInHistories"
                        :key="index"
                        class="grid grid-cols-12 border-b-2 dark:border-dark-5"
                      >
                        <div
                          class="col-span-2 border-l-2 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{
                            (listQuery.page - 1) * listQuery.limit + index + 1
                          }}
                        </div>
                        <div
                          class="col-span-3 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{ trans.agency.name }}
                        </div>
                        <div
                          class="col-span-2 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{ trans.moneyType == 1 ? "현금" : "이체" }}
                        </div>
                        <div
                          class="col-span-3 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{ $h.filterCurrency(trans.amount) }}
                        </div>
                        <div
                          class="col-span-2 border-r-2 dark:border-dark-5 whitespace-no-wrap text-center sm:flex justify-center items-center"
                        >
                          <button
                            class="button button--sm w-15 mr-1 bg-theme-12 text-white"
                            @click="clickEditBtn(trans)"
                          >
                            수정
                          </button>
                          <button
                            class="button button--sm w-15 mr-1 bg-theme-6 text-white"
                            @click="clickDeleteBtn(trans)"
                          >
                            삭제
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-span-6">
                      <div
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                      >
                        출금
                      </div>
                      <div
                        v-for="(trans, index) in transOutHistories"
                        :key="index"
                        class="grid grid-cols-12 border-b-2 dark:border-dark-5"
                      >
                        <div
                          class="col-span-2 border-l-2 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{
                            (listQuery.page - 1) * listQuery.limit + index + 1
                          }}
                        </div>
                        <div
                          class="col-span-3 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{ trans.agency.name }}
                        </div>
                        <div
                          class="col-span-2 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{ trans.moneyType == 1 ? "현금" : "이체" }}
                        </div>
                        <div
                          class="col-span-3 border-r-2 dark:border-dark-5 whitespace-no-wrap p-3 text-center"
                        >
                          {{ $h.filterCurrency(trans.amount) }}
                        </div>
                        <div
                          class="col-span-2 border-r-2 dark:border-dark-5 whitespace-no-wrap text-center sm:flex justify-center items-center"
                        >
                          <button
                            class="button button--sm w-15 mr-1 bg-theme-12 text-white"
                            @click="clickEditBtn(trans)"
                          >
                            수정
                          </button>
                          <button
                            class="button button--sm w-15 mr-1 bg-theme-6 text-white"
                            @click="clickDeleteBtn(trans)"
                          >
                            삭제
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Bordered Table -->
      </div>
    </div>
    <!-- BEGIN: Delete Confirmation Modal -->
    <div
      id="delete-confirmation-modal"
      class="modal"
      @keyup:enter="handleDelete"
    >
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
          <div class="text-3xl mt-5 mb-5">삭제 하시겠습니까?</div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
            type="button"
            data-dismiss="modal"
            class="button w-24 border text-gray-700 mr-1"
          >
            취소
          </button>
          <button
            type="button"
            data-dismiss="modal"
            class="button w-24 bg-theme-6 text-white"
            @click="handleDelete"
          >
            삭제
          </button>
        </div>
      </div>
    </div>
    <!-- END: Delete Confirmation Modal -->
    <div id="edit-modal-preview" class="modal">
      <div class="modal__content">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
        >
          <h2 class="font-medium text-base mr-auto">입출금</h2>
          <a
            data-dismiss="modal"
            href="javascript:;"
            class="absolute right-0 top-0 mt-3 mr-3"
          >
            <xIcon class="w-8 h-8 text-gray-500" />
          </a>
        </div>
        <div class="px-10 py-5 grid grid-cols-12 row-gap-2">
          <div class="col-span-12">
            <div
              class="flex flex-col sm:flex-row items-center"
              @keyup.enter="onModalEnter()"
            >
              <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                형식
              </label>
              <template v-if="register.type == 1">
                <button
                  class="button w-24 mr-2 mb-2 bg-theme-9 text-white"
                  @click="onChangeTransType(1)"
                >
                  입금
                </button>
                <button
                  class="button w-24 ml-2 mb-2 border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
                  @click="onChangeTransType(2)"
                >
                  출금
                </button>
              </template>
              <template v-else>
                <button
                  class="button w-24 mr-2 mb-2 border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
                  @click="onChangeTransType(1)"
                >
                  입금
                </button>
                <button
                  class="button w-24 ml-2 mb-2 bg-theme-9 text-white"
                  @click="onChangeTransType(2)"
                >
                  출금
                </button>
              </template>
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                지점
              </label>
              <div
                class="w-full border rounded-md sm:w-auto relative mt-3 sm:mt-0"
              >
                <SearchIcon
                  class="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0 z-10 text-gray-700 dark:text-gray-300"
                />
                <input
                  id="agency_id"
                  v-model="register.agencyName"
                  type="text"
                  class="input w-full sm:w-64 px-10 text-gray-700 dark:text-gray-300"
                  autocomplete="off"
                  placeholder="지점이름"
                  @focus="showSearchDropdown"
                  @blur="hideSearchDropdown"
                  @input="onChangeInput($event)"
                  @keyup.enter="enterSelect()"
                />
                <div
                  class="inbox-filter dropdown absolute inset-y-0 mr-3 right-0 flex items-center"
                >
                  <ChevronDownIcon
                    class="dropdown-toggle w-4 h-4 cursor-pointer text-gray-700 dark:text-gray-300"
                    @focus="showSearchDropdown"
                    @blur="hideSearchDropdown"
                  />
                </div>
                <div
                  class="dropdown-box w-full"
                  :class="{ show: searchDropdown }"
                >
                  <div
                    class="dropdown-box__content box dark:bg-dark-1 p-2 overflow-y-auto h-32"
                  >
                    <a
                      v-for="(agency, index) in agencies"
                      :key="index"
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                      @click="onSelect(agency)"
                      >{{ agency.name }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                선택
              </label>
              <select
                v-model="register.moneyType"
                type="text"
                class="input input--lg border w-full lg:w-auto mt-2 flex-1"
              >
                <option value="1">
                  <h2 class="font-medium text-base mr-auto">
                    현금
                  </h2>
                </option>
                <option value="2">
                  <h2 class="font-medium text-base mr-auto">
                    이체
                  </h2>
                </option>
              </select>
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-20 sm:text-left sm:mr-5">
                가격
              </label>
              <input
                v-model="tempAmount"
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
                @input="handleFormatAmount"
                @keyup.enter="onModalEnter()"
              />
            </div>
          </div>
        </div>
        <div
          class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
        >
          <button
            type="button"
            data-dismiss="modal"
            class="button w-20 border text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
          >
            취소
          </button>
          <button
            type="button"
            data-dismiss="modal"
            class="button w-20 bg-theme-1 text-white"
            @click="onModalEnter"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Toastify from "toastify-js";
import { export_json_to_excel } from "@/assets/js/vendor/Export2Excel";

export default {
  data() {
    return {
      agencyId: "",
      agencies: [],
      tmpAgencies: [],
      transInHistories: [],
      transOutHistories: [],
      selectedDay: "",
      total: 0,
      listQuery: {
        page: 1,
        limit: 10
      },
      register: {
        id: -1,
        type: 1,
        moneyType: 1,
        agencyId: "",
        agencyName: "",
        amount: ""
      },
      searchDropdown: false,
      tempAmount: ""
    };
  },
  async mounted() {
    await this.tokenLogin();
    this.selectedDay = moment(new Date()).format("YYYY-MM-DD");
    await this.getAgencies();
    await this.getTransIn();
    await this.getTransOut();
  },
  methods: {
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
    clickPlusBtn() {
      this.register.id = -1;
      this.register.amount = "";
      this.register.type = 1;
      this.register.moneyType = 1;
      this.register.agencyId = "";
      this.register.agencyName = "";
      this.agencies = this.$h.removeItemFromArray(
        this.tmpAgencies,
        this.agencyId
      );
      this.tempAmount = "￦ ";
      cash("#edit-modal-preview").modal("toggle");
    },
    clickEditBtn(trans) {
      this.register.id = trans.id;
      this.register.amount = trans.amount;
      if (this.agencyId == trans.toAgencyId) {
        this.register.type = 1;
      } else {
        this.register.type = 2;
      }
      this.register.moneyType = trans.moneyType;
      this.register.agencyId = trans.agency.id;
      this.register.agencyName = trans.agency.name;
      this.tempAmount =
        "￦ " + parseInt(String(this.register.amount)).toLocaleString();
      cash("#edit-modal-preview").modal("toggle");
    },
    clickDeleteBtn(trans) {
      if (cash("#delete-confirmation-modal").hasClass("show")) {
        this.handleDelete();
      }
      this.register.id = trans.id;
      cash("#delete-confirmation-modal").modal("toggle");
    },
    handleFormatAmount() {
      const numericValue = parseInt(this.tempAmount.replace(/[^0-9]/g, "")); // 숫자만 추출
      if (!isNaN(numericValue)) {
        this.register.amount = numericValue;
        this.tempAmount = "₩ " + numericValue.toLocaleString(); // 통화 형식으로 포맷팅
      } else {
        this.register.amount = 0;
        this.tempAmount = "";
      }
    },
    onModalEnter() {
      if (this.register.id == -1) {
        this.handleRegister();
      } else {
        this.handleUpdate();
      }
    },
    async handleRegister() {
      let fromAgencyId = 0;
      let toAgencyId = 0;
      if (this.register.type == 1) {
        toAgencyId = this.agencyId;
        fromAgencyId = this.register.agencyId;
      } else {
        toAgencyId = this.register.agencyId;
        fromAgencyId = this.agencyId;
      }
      let data = {
        type: this.register.type,
        moneyType: this.register.moneyType,
        amount: this.$h.convertCommaStrToInt(this.register.amount),
        fromAgencyId: fromAgencyId,
        toAgencyId: toAgencyId,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      if (this.$h.isEmpty(this.register.agencyId)) {
        Toastify({
          text: "지점을 선택해주세요.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      this.tempAmount = "";
      cash("#edit-modal-preview").modal("hide");
      await axios.post(this.$api().addTrans, data).then(res => {
        if (res.status == 200) {
          this.updateTable();
        }
      });
    },
    async handleDelete() {
      let data = {
        id: this.register.id,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().deleteTrans, data).then(res => {
        if (res.status == 200) {
          this.updateTable();
        }
      });
    },
    async handleUpdate() {
      let fromAgencyId = 0;
      let toAgencyId = 0;
      if (this.register.type == 1) {
        toAgencyId = this.agencyId;
        fromAgencyId = this.register.agencyId;
      } else {
        toAgencyId = this.register.agencyId;
        fromAgencyId = this.agencyId;
      }
      let data = {
        id: this.register.id,
        moneyType: this.register.moneyType,
        amount: this.$h.convertCommaStrToInt(this.register.amount),
        fromAgencyId: fromAgencyId,
        toAgencyId: toAgencyId,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      if (this.$h.isEmpty(this.register.agencyId)) {
        Toastify({
          text: "지점을 선택해주세요.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      this.tempAmount = "";
      cash("#edit-modal-preview").modal("hide");
      await axios.post(this.$api().editTrans, data).then(res => {
        if (res.status == 200) {
          this.updateTable();
        }
      });
    },
    async updateTable() {
      await this.getTransIn();
      await this.getTransOut();
    },
    async getAgencies() {
      await axios.post(this.$api().getAgencies).then(res => {
        let resultData = this.$h.assign(res.data);
        this.tmpAgencies = [...resultData.data];
        if (this.tmpAgencies.length > 0) {
          this.agencyId = this.tmpAgencies[0].id;
        }
      });
    },
    async getTransIn() {
      let data = {
        type: 1,
        limit: this.listQuery.limit,
        offset: (this.listQuery.page - 1) * this.listQuery.limit,
        agencyId: this.agencyId,
        day: this.selectedDay,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getTrans, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.transInHistories = resultData.data;
        this.total = resultData.total;
      });
    },
    async getTransOut() {
      let data = {
        type: 2,
        limit: this.listQuery.limit,
        offset: (this.listQuery.page - 1) * this.listQuery.limit,
        agencyId: this.agencyId,
        day: this.selectedDay,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getTrans, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.transOutHistories = resultData.data;
        this.total = resultData.total;
      });
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    onSelect(agency) {
      this.register.agencyName = agency.name;
      this.register.agencyId = agency.id;
    },
    enterSelect() {
      const agencyName = this.register.agencyName;
      this.agencies = this.$h.findItemsFromArray(this.tmpAgencies, agencyName);
      if (this.agencies.length > 0) {
        this.register.agencyName = this.agencies[0].name;
        this.register.agencyId = this.agencies[0].id;
      } else {
        this.register.agencyName = "";
        this.register.agencyId = "";
      }
    },
    onChangeInput() {
      const agencyName = this.register.agencyName;
      this.agencies = this.$h.findItemsFromArray(this.tmpAgencies, agencyName);
      if (this.agencies.length > 0) {
        this.register.agencyId = this.agencies[0].id;
      } else {
        this.register.agencyId = "";
      }
    },
    onChangeTransType(type) {
      this.register.type = type;
    },
    exportExcel() {
      let th = ["입금"];
      let jsonData = [];
      {
        for (let i = 0; i < this.transInHistories.length; i++) {
          let row = [];
          row.push(i + 1);
          row.push(this.transInHistories[i].agency.name);
          row.push(this.transInHistories[i].moneyType == 1 ? "현금" : "이체");
          row.push(this.$h.filterCurrency(this.transInHistories[i].amount));
          jsonData.push(row);
        }
      }
      {
        let row = [];
        row.push("출금");
        jsonData.push(row);
      }
      {
        for (let i = 0; i < this.transOutHistories.length; i++) {
          let row = [];
          row.push(i + 1);
          row.push(this.transOutHistories[i].agency.name);
          row.push(this.transOutHistories[i].moneyType == 1 ? "현금" : "이체");
          row.push(this.$h.filterCurrency(this.transOutHistories[i].amount));
          jsonData.push(row);
        }
      }
      export_json_to_excel(th, jsonData, "tablePrint");
    }
  }
};
</script>
